<template>
    <default needs-project>
        <div id="kv_main">
            <div id="kv_namespaces">
                <custom-dropdown @ddChange="selectNamespace" v-model="selectedNamespace" icon="fa-database" name="Namespace" :data="namespaces">
                    <create-new-input-button @confirm="createNamespace($event)">New Namespace</create-new-input-button>
                </custom-dropdown>
            </div>
            <div id="kv_types">
                <custom-dropdown v-show="namespace" @ddChange="selectType" v-model="selectedType" icon="fa-table" name="Type" :data="types">
                    <create-new-input-button @confirm="createType($event)">New Type</create-new-input-button>
                </custom-dropdown>
            </div>
            <div id="kv_settings">
                <div id="kv_settings_main">
                    {{ entityInfoOpen }}
                    <button @click="createEntity()"></button>
                </div>
            </div>
            <div id="kv_manager">

            </div>
            <div id="kv_entities" ref="kventities" @click="toggleNewEntity(false)">
                <type-table v-if="type && type.entities" @checkedEntity="checkedE($event)" @checkedState="checkedS($event)" :table="type"></type-table>
            </div>
            <div id="kv_entity" v-if="entityInfoOpen || newEntityOpen">
                <entity-info v-if="entityInfoOpen" :checked="entityChecked" :key="entityChecked.id"></entity-info>
                <new-entitiy v-if="newEntityOpen"></new-entitiy>
            </div>
        </div>
    </default>
</template>

<script>
import Default from '../components/layouts/Default'
import CustomDropdown from '../components/miscellaneous/customDropdown'
import TypeTable from '../components/kv/typeTable'
import CreateNewInputButton from '../components/miscellaneous/createNewInputButton'
import NewEntitiy from '../components/kv/newEntitiy'
import EntityInfo from '../components/kv/entityInfo'
import { mixin as clickaway } from 'vue-clickaway'
export default {
  name: 'Kv',
  mixins: [clickaway],
  components: {
    EntityInfo,
    NewEntitiy,
    CreateNewInputButton,
    TypeTable,
    CustomDropdown,
    Default
  },
  data () {
    return {
      selectedNamespace: null,
      selectedType: null,
      entityChecked: null,
      entitiesCheckedState: null,
      newEntityOpen: false
    }
  },
  computed: {
    namespaces () {
      return this.$store.getters['Kvs/get_namespaces']
    },
    namespace () {
      return this.$store.getters['Kvs/get_namespace']
    },
    types () {
      return this.$store.getters['Kvs/get_types']
    },
    type () {
      return this.$store.getters['Kvs/get_type']
    },
    entities () {
      return this.$store.getters['Kvs/get_entities']
    },
    entityInfoOpen () {
      return !this.newEntityOpen && this.entitiesCheckedState === 'o'
    }
  },
  methods: {
    selectNamespace () {
      this.$store.commit('Kvs/set_namespace', this.selectedNamespace)
      this.$store.commit('Kvs/set_type', null)
      this.selectedType = null
      this.entitiesCheckedState = 'n'
      this.api_index_types()
    },
    selectType () {
      this.$store.commit('Kvs/set_type', this.selectedType)
      this.entitiesCheckedState = 'n'
      this.api_one_type()
    },
    api_index_namespaces () {
      this.$store.dispatch('Kvs/api_index_namespaces')
    },
    api_index_types () {
      this.$store.dispatch('Kvs/api_index_types')
    },
    api_one_type () {
      this.$store.dispatch('Kvs/api_one_type')
    },
    createNamespace (data) {
      this.$store.dispatch('Kvs/api_create_namespace', { name: data })
    },
    createType (data) {
      this.$store.dispatch('Kvs/api_create_type', { name: data })
    },
    createEntity () {
      this.$store.dispatch('Kvs/api_create_entity', { data: {'wtf': 'adsasd'} })
    },
    checkedE (data) {
      this.entityChecked = data
    },
    checkedS (data) {
      this.entitiesCheckedState = data
    },
    toggleNewEntity (state) {
      this.newEntityOpen = state
    }
  },
  mounted () {
    this.$store.commit('Kvs/set_namespace', null)
    this.$store.commit('Kvs/set_type', null)
    this.api_index_namespaces()
  }
}
</script>

<style scoped>
    #kv_main{
        display: grid;
        width: 100%;
        grid-template-areas:
            "namespaces types settings entity"
            "manager manager settings entity"
            "entities entities entities entity";
        grid-auto-rows: 40px 40px auto;
        grid-auto-columns: 250px 250px 1fr auto;
        grid-gap: 10px;
    }
    #kv_namespaces{
        grid-area: namespaces;
        height: 100%;
        width: 100%;
    }
    #kv_types{
        grid-area: types;
        height: 100%;
        width: 100%;
    }
    #kv_settings{
        grid-area: settings;
        height: 100%;
        width: 100%;
    }
    #kv_settings>button{
        padding-left: 10px;
        padding-right: 10px;
        margin-right: 5px;
    }
    #kv_entities{
        width: 100%;
        height: 100%;
        grid-area: entities;
    }
    #kv_manager{
        width: 100%;
        height: 100%;
        grid-area: manager;
    }
    #kv_entity{
        width: 100%;
        height: 100%;
        grid-area: entity;
        border: 1px solid var(--color-gray);
    }
    #kv_settings_main{
        display: flex;
        height: 100%;
        width: 100%;
        border: 1px solid var(--color-gray);
    }
</style>
